const CURRENCY_SYMBOLS = {
  'USD': '$ ', // US Dollar
  'AUD': 'AU$ ', // Autraliano Dollar
  'EUR': '€ ', // Euro
  'CRC': '₡ ', // Costa Rican Colón
  'GBP': '£ ', // British Pound Sterling
  'ILS': '₪ ', // Israeli New Sheqel
  'INR': '₹ ', // Indian Rupee
  'JPY': '¥ ', // Japanese Yen
  'KRW': '₩ ', // South Korean Won
  'NGN': '₦ ', // Nigerian Naira
  'PHP': '₱ ', // Philippine Peso
  'PLN': 'zł ', // Polish Zloty
  'PYG': '₲ ', // Paraguayan Guarani
  'THB': '฿ ', // Thai Baht
  'UAH': '₴ ', // Ukrainian Hryvnia
  'VND': '₫ ', // Vietnamese Dong
}

const convertNameToSymbol = currencyName => {
  currencyName = !currencyName || isFinite(currencyName) ? '' : currencyName.toUpperCase()
  if (!!CURRENCY_SYMBOLS[currencyName]) {
    return CURRENCY_SYMBOLS[currencyName]
  }
  return '€ '
}

export default {
  convertNameToSymbol,
}



// WEBPACK FOOTER //
// ./src/utils/currency.js